"use client";

import type { GuidepostEntry, SearchSection } from "../types";
import { RESOURCE_TYPES, getSearchSections } from "../constants";
import { fetchUniversalSearch } from "./fetchers";
import { useAsyncData } from "./useAsyncData";

const NO_SECTIONS: SearchSection[] = [];

export function useUniversalSearch(query: string) {
  const { data, loading, error } = useAsyncData(
    [query],
    (signal) =>
      fetchUniversalSearch(query, Object.values(RESOURCE_TYPES), 5, signal),
    { enabled: query !== "" },
  );

  const guidepost: GuidepostEntry | undefined =
    (data?.guideposts?.results?.[0] as GuidepostEntry) ?? undefined;
  const searchSections = data ? getSearchSections(data) : NO_SECTIONS;
  const indexesWithResults = searchSections.filter(
    (section) => section.data?.results && section.data.results.length > 0,
  );

  return {
    searchResults: data,
    guidepost,
    searchSections,
    indexesWithResults,
    loading,
    // `data` is cleared whenever the query changes, so a present result always
    // belongs to the query currently in the box.
    resolvedQuery: data ? query : "",
    error,
  };
}
